import { NftSkinItemRarity } from 'src/utils/types';
export const colorMap = {
  [NftSkinItemRarity.NORMAL]: {
    displayValue: 'Normal',
    color: 'normal'
  },
  [NftSkinItemRarity.RARE]: {
    displayValue: 'Rare',
    color: 'rare'
  },
  [NftSkinItemRarity.MYTHICAL]: {
    displayValue: 'Mythical',
    color: 'mythical'
  }
};